// bazaarui — en. Bazaar/Market page chrome: product detail, cart, checkout,
// delivery, seller store, product card, and the shared buy-flow labels.

export default {
  // ProductCard
  cardSold: (n) => `${n} sold`,
  cardBundle: 'Bundle',
  cardOnlyLeft: (n) => `Only ${n} left`,
  cardColorsTitle: (c) => `Available colors: ${c}`,
  cardAllColorsTitle: 'Available in all colors',
  cardColorsCount: (n) => `${n} colors`,

  // ProductDetailPage
  pdWishlistToast: '... added to wishlist!',
  pdLinkCopied: 'Link copied to clipboard!',
  pdNotFound: 'Product not found',
  pdBrowseBazaar: 'Browse Bazaar',
  pdSignInTitle: 'Sign In Required',
  pdSignInDesc: 'You need to be logged in to add items to your wishlist.',
  pdSignInCta: 'Sign In',
  pdRegisterBuyer: 'Register as Buyer',
  pdCancel: 'Cancel',
  pdSoldOut: 'Sold Out',
  pdOffPct: (p) => `-${p}% OFF`,
  pdShare: 'Share',
  pdAvailableColors: 'Available Colors',
  pdAllColors: 'All Colors',
  pdOnlyLeft: (n) => `Only ${n} Left!`,
  pdLikeLabel: 'Like this product',
  pdLikeAction: 'Like',
  pdUnlike: 'Unlike',
  pdLikeOne: 'Like',
  pdLikes: 'Likes',
  pdViewOne: 'View',
  pdViews: 'Views',
  pdDescription: 'Description',
  pdNoDescription: 'No description provided.',
  pdWhatsIncluded: "What's Included",
  pdSoldBy: 'Sold by',
  pdStore: 'Store',
  pdQuantity: 'Quantity',
  pdSubtotal: 'Subtotal',
  pdAddToWishlist: 'Add to Wishlist',
  pdAddedToWishlist: 'Added to Wishlist',
  pdChatWithSeller: 'Chat with Seller',
  pdDeliveryTitle: 'Delivery',
  pdDeliveryDesc: 'Direct from seller',
  pdSecureTitle: 'Secure',
  pdSecureDesc: 'Verified Payment',
  pdAuthenticTitle: 'Authentic',
  pdAuthenticDesc: 'Verified Seller',

  // CartPage
  cartEmptyTitle: 'Your Wishlist is Empty',
  cartEmptyDesc: "Looks like you haven't saved anything yet.",
  cartBrowse: '← Browse Bazaar',
  cartBack: '← Back to Bazaar',
  cartTitle: 'Your Wishlist',
  cartStore: 'Store:',
  cartItems: '📦 Items',
  cartUnit: 'Unit:',
  cartDecrease: 'Decrease quantity',
  cartIncrease: 'Increase quantity',
  cartRemoveItem: 'Remove item',
  cartTotal: 'Wishlist Total',

  sellerContactTitle: 'Seller Contact',
  sellerContactHint: 'Save this number to reach the seller directly.',
  sellerContactTelegram: 'Message on Telegram',

  // SellerStorePage
  spSignInToSave: 'Please sign in to add to wishlist',
  spNoProducts: 'No products found for seller',
  spVerifiedSeller: 'Verified All Things Bazaar Seller',

  // CheckoutPage
  coTitle: 'Checkout',
  coFastYango: 'Fast motorbike delivery via Yango',
  coYangoDesc: 'Ride motorcycle courier service',
  coRideDesc: 'Ride motorcycle courier service',
  coGlovo: 'Glovo',
  coGlovoDesc: 'On-demand delivery service',
  coLalamove: 'Lalamove',
  coLalamoveDesc: 'Same-day courier delivery',
  coOtherCourier: 'Other Courier',
  coOtherCourierDesc: 'Local delivery courier',
  coPickup: 'No Delivery (Pickup)',
  coPickupDesc: 'I will collect my order myself',
  coDelivery: 'Delivery',
  coPayment: 'Payment',
  coSelectPlaceholder: 'Please select...',
  coSelectShort: 'Select...',
  coSelectDelivery: 'Please select a delivery option.',
  coDeliveryIntro: "Select how you'd like to receive your order in Ethiopia.",
  coSuccessTitle: 'Order Successful!',
  coOrderId: 'Order ID:',
  coDeliveryVia: 'Delivery via:',
  coBackToBazaar: 'Back to Bazaar',
  coOrderSummary: 'Order Summary',
  coQty: 'Qty:',
  coTotal: 'Total',
  coChooseDelivery: 'Choose Delivery Method',
  coContinuePayment: 'Continue to Payment',
  coDeliveryMethod: 'Delivery Method',
  coChange: 'Change',
  coTransferTo: 'Transfer To:',
  coPaymentProof: 'Payment Proof',

  // DeliveryPage
  dlReceivedTitle: 'Request Received!',
  dlRequestId: 'Delivery Request ID:',
  dlBackToBazaar: '← Back to Bazaar',
  dlOrderNum: 'Order #',

  // BazaarPage / MarketPage
  bzOpensIn: 'Opens in',
  bzHeroTitle: 'Bazaar',
  bzHeroDesc: 'Shop from verified Ethiopian sellers — handcrafted goods, fashion, food & more.',
  bzSaveEtb: 'You save ETB',
  bzInStockOnly: 'In Stock Only',
  bzClearFilters: 'Clear all filters',
};